import styled from "@emotion/styled";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

export const RiepilogoPreventivoStickyWidget = styled.div`
    
    .tpd-riepilogo-preventivatore {
        position: fixed;
        left: 0;
        bottom: 0px;
        width: 100%;
        z-index: 999;
        background-color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$blue"]};
        min-height: 150px;
        padding-top: 20px;
        font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$normal"]};
        font-size: 18px;
        line-height: 29px;
        color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};

        &.is_loading {
            padding-top: 0;
        }

        .tpd-loading .sk-circle {
            height: 100px;
            width: 100px;
            top: 30px;
        }

        .tpd_close {
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
        }

        .tpd_mobile_txt {
            font-size: 20px;
            line-height: 24px;
        }

        .tpd_btn {
            ${Styles.MixinsUtils.mainTabBtnWhite}
            ${Styles.MixinsUtils.btnHeightAdapt}

            &:hover {
                border: none;
            }
        }

        .tpd_mobile_prev_container {
            padding-left: 60px;
            padding-right: 60px;

            .tpd_btn {
                margin-top: 15px;
            }
        }

        .tpd-loading .sk-circle {
            margin: 0 auto;
        }

        /* TABLET */
        ${Styles.BreakpointsUtils.tabletAndDesktopOnly(`
            min-height: 160px;
            padding-top: 18px;
            &.is_loading {
                padding-top: 0;
            }
            .tpd_txtBig {
                font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$bold"]};
                font-size: 30px;
            }
            .tpd_txtO {
                margin-top: 47px;
            }
            .tpd_section2 {
                margin-top: 9px;
            }

            .tpd_whiteLine {
                min-height: 124px;
                width: 2px;
                float: right;
                background-color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            }
            .tpd_icon {
                position: absolute;
                left: 0;
                top: calc(50% - 35px);
                font-size: 69px;
                height: auto;
                margin-right: 10px;
            }
            .tpd_btn {
                width: auto;
            }
            .tpd_txtWrapper {
                padding-right: 20px;
                padding-left: 80px;
                // margin-top: 12px;
                margin-left: 12px;
            }
            .tpd_txt:not(:first-child) {
                margin-top: 10px;
            }
            .tpd_barrato {
                text-decoration: line-through;
            }
            .tpd_premioScontato,
            .tpd_premioAnnuale {
                display: block;
            }
            .tpd_txtMedium {
                font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$bold"]};
                font-size: 24px;
                display: inline;
            }
            .tpd_txtVeicolo,
            .tpd_txtTarga {
                display: block;
            }
            .tpd_privacy {
                white-space: normal;
                ${Styles.MixinsUtils.mainLinkWhite}
                &:active,
                &:focus {
                    text-decoration: underline;
                    outline: none !important;
                    box-shadow: none;
                    color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
                }
            }
            .tpd_btnWrap {
                margin-top: 11px;
            }

            .tpd_close {
                display: block;
                position: absolute;
                right: 10px;
                top: 10px;
                .tpd_iconClose {
                    font-size: 25px;
                }
            }
        `)} 
            
        /*DESKTOP*/
        ${Styles.BreakpointsUtils.desktopOnly(`
            min-height: 132px;
            padding-top: 21px;
            &.is_loading {
                padding-top: 0;
            }
            .tpd-loading .sk-circle {
                top: 20px;
            }
            .tpd_txtDin {
                white-space: normal;
            }
            .tpd_txtO {
                margin-top: 36px;
            }

            .tpd_txtWrapper {
                margin-top: 21px;
                margin-left: 13px;
            }
            .tpd_whiteLine {
                min-height: 91px;
            }
            .tpd_premioScontato,
            .tpd_premioAnnuale {
                display: inline;
            }
            .tpd_txtVeicolo,
            .tpd_txtTarga {
                display: inline;
            }
            .tpd_txt {
                display: inline;
            }
        `)}
    }
`;